module.exports = __webpack_public_path__ + "static/media/mobile.2a4353b6.png";